import { OrderedColumnsT } from 'business/definitions';
import { getBestSuitableRemainingColumn } from './helpers';

/**
 * Finds the ordered columns of a treemap visualization.
 * There are no specific rule, we simply put the best suitable column as x and the remaining one as z.
 */
export const getTreeMapVizOrderedColumns = (
    chartColumns: ResponseColumnT[],
    metricColumn: ResponseColumnT,
): OrderedColumnsT => {
    const remainingItem = getBestSuitableRemainingColumn(chartColumns, [
        metricColumn.key,
    ]);
    if (!remainingItem)
        return {
            y: metricColumn,
        };
    return {
        x: getBestSuitableRemainingColumn(chartColumns, [
            metricColumn.key,
            remainingItem.key,
        ]),
        y: metricColumn,
        z: remainingItem,
    };
};
